.homePage {
    // Design requested a one-off scheme for the home page where, on desktop,
    // consecutive SplitBlocks will overlap each other.
    --offset: calc(var(--spacer-120) * -1);
    --offset-half: calc(var(--offset) / 2);

    // .splitLayoutDesktopStatic was defined as a global (that is, not module)
    // class in SplitBlock
    :global(.splitLayoutDesktopStatic) {
        // SplitBlock is set up with HeroSet, which means we expect one SplitBlock
        // to have multiple divs for multiple layouts. So this selector says:
        // "If the SplitBlock has any sibling, and that has a sibling that
        // has the global class, then we want to do something to this SplitBlock."
        &:has(+ * + * + :global(.splitLayoutDesktopStatic)) {
            // This is the inner container on every Flexihero
            > div {
                // The first child is the content div
                > *:first-child {
                    transform: translateY(var(--offset-half));
                    text-align: center;
                }
            }
        }

        // This selector says: "If the SplitBlock has any sibling, and that has
        // a sibling that has the global class, then we want to do something to
        // that SplitBlock."
        + * + * + :global(.splitLayoutDesktopStatic) {
            // This cancels out the offsetting to prevent extra white space
            // under the block.
            margin-bottom: var(--offset);

            // This is the inner container on every Flexihero
            > div {
                // The first child is the content div
                > *:first-child {
                    transform: translateY(var(--offset-half));
                    text-align: center;
                }

                // The last child is the media div
                > *:last-child {
                    transform: translateY(var(--offset));
                }
            }
        }
    }
}
